module.exports = __webpack_public_path__ + "static/img/activity_list.253078d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_list.png
// module id = 0Rae
// module chunks = 128